import { Component } from '@angular/core';
import { AlertController, IonicPage, LoadingController, ModalController, NavController, NavParams } from 'ionic-angular';
import { Subscription } from 'rxjs';
import { ApiProvider } from '../../providers/api/api';
import * as firebase from 'Firebase';
import { a } from '@angular/core/src/render3';
// import { SubscriptionPage } from '../subscription/subscription';
import { RfqPage } from '../rfq/rfq';
import { DatePipe } from '@angular/common';
// import { TabsPage } from '../tabs/tabs';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AddLeadsModel } from '../leads-tabs/leads-tabs';
// import { StartLeadsPage } from '../start-leads/start-leads';

/**
 * Generated class for the SearchPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-search',
  templateUrl: 'search.html',
})
export class SearchPage {
  items_data: any; restricteddata: any = []; finalrestrictdata: any = []; credits: any;
  search: any;
  ProductData: any[] = [];
  allCountrys: any[] = [];
  rooms;
  otherCnCheck: boolean = false;
  labledisplay: boolean = false;
  alertCountry: any;
  country: any;
  favIcon = 'ios-heart-outline';
  favs: boolean = true;
  subscription: Subscription;
  country_id: any;
  ref = firebase.database().ref('chatrooms/');
  loginAuth;
  currentdate: any;
  geo_country_id: any; loading: any;
  constructor(public loadingCtrl: LoadingController, private datePipe: DatePipe, public navCtrl: NavController, public navParams: NavParams, private apiProvider: ApiProvider, private alertCtrl: AlertController, private modalCtrl: ModalController) {
    this.loginAuth = JSON.parse(localStorage.getItem('user_data'))
    this.geo_country_id = localStorage.getItem('geo_country_id');
    var myDate: String = new Date().toISOString();
    this.currentdate = this.datePipe.transform(myDate, 'yyyy-MM-dd');
    this.subscription = this.apiProvider.currentCountrys.subscribe(message => this.allCountrys = message);
    if (this.allCountrys.length == 0) this.getContinent();
    // this.getContinent();
    var userData = JSON.parse(localStorage.getItem('user_data'));
    if (localStorage.getItem('user_data')) {
      this.country_id = userData[0].usr_country
    }
    this.getcreditsdata();
    this.leadrestrictioncnts();
    this.getSearchData(undefined);
  }

  ionViewDidLoad() {

    console.log('ionViewDidLoad SearchPage');
  }

  private getContinent() {
    this.apiProvider.getSearchallCountrys();
  }

  importdutiesdata(importdata, ind) {
    console.log(importdata);

    if (ind == 1) {
      const alert = this.alertCtrl.create({
        cssClass: 'my-custom-class',
        title: 'Export Policy : ',
        mode: 'ios',
        subTitle: importdata.export_policies,
        buttons: ['OK']
      });
      alert.present();
    } else if (ind == 2) {
      const alert = this.alertCtrl.create({
        cssClass: 'my-custom-class',
        title: 'Import Policy : ',
        mode: 'ios',
        subTitle: importdata.import_policies,
        buttons: ['OK']
      });
      alert.present();
    } else if (ind == 3) {
      console.log(importdata.local_policies);
      // const alert = this.alertCtrl.create({
      //   cssClass: 'my-custom-class',
      //   title: 'Local Policy : ',
      //   mode: 'ios',
      //   subTitle: importdata.local_policies,
      //   buttons: ['OK']
      // });
      // alert.present(); 
    }

    // if (importdata == '0') {
    //   // alert('Contact your Contry Eports Imports panel');
    //   this.importDutiesAlert(id,ind)
    // } else {
    //   window.open(importdata)
    // }

  }


  importDutiesAlert(id, ind) {

    const confirm = this.alertCtrl.create({
      cssClass: 'my-custom-class',
      title: 'Currently No Policiy Link Found',
      message: 'Do You Have An Awareness Regarding Policies Link..!',
      mode: 'ios',
      buttons: [
        {
          text: 'No',
          handler: () => {
            // console.log('Disagree clicked');
          }
        },
        {
          text: 'Yes',
          handler: () => {

            let modal = this.modalCtrl.create(AddPoliciesModel, { poli: this.ProductData[id], indc: ind });
            modal.present();

            // this.finaldeductionAlert()
          }
        }
      ]
    });
    confirm.present();

  }

  leadrestrictioncnts() {
    var userdata = JSON.parse(localStorage.getItem('user_data'));
    if (userdata) {
      var data = {
        'indicator': 1,
        'usr_id': userdata[0].usr_id,
      }
      this.apiProvider.getrestrictiondata(data).subscribe((res: any) => {
        console.log(res.data);
        this.restricteddata = res.data;

        // this.agenciesdata = res.data;
      }, er => {
        console.log(er);
      })
    }
  }



  addRfqBucket(id) {
    var usrData = this.loginAuth[0].reportdata.filter(word => (word.chapterend >= this.currentdate));
    console.log(usrData);
    if (this.loginAuth) {
      if (usrData.length != 0) {
        this.finalrestrictdata = this.restricteddata.filter(word => word.lead_ctgry_restrict_type_id == 5);
        //  this.finalrestrictdata = this.restricteddata.filter(rest => rest.type_description.includes(filterdata[0].lead_ctgry_nm));
        console.log(this.finalrestrictdata);
        if (this.finalrestrictdata.length > 0) {
          const confirm = this.alertCtrl.create({
            cssClass: 'my-custom-class',
            message: 'Are you sure want to use one Credit? \n\n Balance Credits: ' + this.credits,
            mode: 'ios',
            buttons: [
              {
                text: 'Disagree',
                handler: () => {
                  console.log('Disagree clicked');
                }
              },
              {
                text: 'Agree',
                handler: () => {
                  this.finaldeductionAlert(this.ProductData[id])
                }
              }
            ]
          });
          confirm.present();
          // let modal = this.modalCtrl.create(AddPoliciesModel, {poli: this.ProductData[id], indc: null});
          //   modal.present();
        } else {
          const alert = this.alertCtrl.create({
            cssClass: 'my-custom-class',
            title: 'Sorry!',
            subTitle: ' <br>You have reached your limit. Kindly refill with subscription',
            mode: 'ios',
            buttons: [{
              text: 'Ok',
              handler: () => {

              }
            },
            ]

          });
          alert.present();
        }

      } else {
        this.subscribtionalert();
      }
    } else {
      this.loginInfoAlert()
    }
  }
  finaldeductionAlert(id) {
    const confirm = this.alertCtrl.create({
      cssClass: 'my-custom-class',
      title: 'Balance Credits Deduction History',
      message: `${this.credits} - 1 = ${this.credits - 1} `,
      mode: 'ios',
      buttons: [
        {
          text: 'Disagree',
          handler: () => {
            console.log('Disagree clicked');
          }
        },
        {
          text: 'Agree',
          handler: () => {

            const country = JSON.parse(localStorage.getItem('user_data'))
            if (this.credits != 0) {
              let modal = this.modalCtrl.create(AddPoliciesModel, { poli: id, indc: null });
              modal.present();

            } else {
              alert('Please refill Credits')
            }
          }
        }
      ]
    });
    confirm.present();
  }
  getcreditsdata() {
    var country = JSON.parse(localStorage.getItem('user_data'));

    if (country) {
      var data = {
        'usr_id': country[0].usr_id
      }
      this.apiProvider.userprofiledata(data).subscribe((res) => {
        var x = [];
        x.push(res);
        this.credits = x[0].data[0].total_credits;
        console.log(this.credits);
      });
    } else {
      this.credits = "0";
    }
  }



  exportdutiesdata(exportdata, ind) {
    if (ind == 1) {
      const alert = this.alertCtrl.create({
        cssClass: 'my-custom-class',
        title: 'Export Duties : ',
        mode: 'ios',
        subTitle: exportdata.export_duties,
        buttons: ['OK']
      });
      alert.present();
    } else if (ind == 2) {
      const alert = this.alertCtrl.create({
        cssClass: 'my-custom-class',
        title: 'Import Duties : ',
        mode: 'ios',
        subTitle: exportdata.import_duties,
        buttons: ['OK']
      });
      alert.present();
    } else if (ind == 3) {
      const alert = this.alertCtrl.create({
        cssClass: 'my-custom-class',
        title: 'Local Duties : ',
        mode: 'ios',
        subTitle: exportdata.local_duties,
        buttons: ['OK']
      });
      alert.present();
    }
    // if (exportdata == '0') {
    //   alert('Currently No Policiy Link Found');
    // } else {
    //   window.open(exportdata)
    // }

  }

  goback() {
    if (this.loginAuth) {
      this.navCtrl.setRoot('HomePage');

    } else {
      this.navCtrl.setRoot('SignupPage', { "sigmentstatus": "login" });
    }
  }



  addToFavs(id) {

    if (this.loginAuth) {
      console.log(this.ProductData[id].fav_hscode_id);
      var userData = JSON.parse(localStorage.getItem('user_data'));
      if (this.ProductData[id].fav_hscode_id == null) {
        if (!this.country_id) {
          var Adddata = {
            'fav_hscode_id': this.ProductData[id].hscode_id,
            // 'country_id': userData[0].usr_country,
            'country_id': this.geo_country_id,
            'usr_id': userData[0].usr_id
          }
        } else {
          var Adddata = {
            'fav_hscode_id': this.ProductData[id].hscode_id,
            // 'country_id': this.country_id,
            'country_id': this.geo_country_id,
            'usr_id': userData[0].usr_id
          }
        }
        this.apiProvider.addfovouritesDtata(Adddata).subscribe((res: any) => {
          this.getSearchData(undefined);
          this.showFavsAlerts(1);
        }, er => {
        })

      } else {
        if (!this.country_id) {
          var Removedata = {
            'favourite_id': this.ProductData[id].favourite_id,
            // 'country_id': userData[0].usr_country,
            'country_id': this.geo_country_id,
            'usr_id': userData[0].usr_id
          }
        } else {
          var Removedata = {
            'favourite_id': this.ProductData[id].favourite_id,
            // 'country_id': this.country_id,
            'country_id': this.geo_country_id,
            'usr_id': userData[0].usr_id
          }
        }
        this.apiProvider.removefovouritesData(Removedata).subscribe((res: any) => {
          this.getSearchData(undefined);
          this.showFavsAlerts(0);
        }, er => {
        })
      }
    } else {
      this.loginInfoAlert();
    }


  }

  loginInfoAlert() {
    const alert = this.alertCtrl.create({
      cssClass: 'my-custom-class',
      title: 'Do You Really Need This Feature ?',
      mode: 'ios',
      subTitle: 'Please Sign in with your Credentials',
      buttons: ['OK']
    });
    alert.present();
  }

  showFavsAlerts(id) {
    if (id == 0) {
      const alert = this.alertCtrl.create({
        cssClass: 'my-custom-class',
        title: 'Sucess',
        mode: 'ios',
        subTitle: 'Successfully Removed From Favourites',
        buttons: ['OK']
      });
      alert.present();
    } else {

      const alert = this.alertCtrl.create({
        cssClass: 'my-custom-class',
        title: 'Sucess',
        mode: 'ios',
        subTitle: 'Successfully Added To Favourites',
        buttons: ['OK']
      });
      alert.present();


    }

  }

  searchedCountryData(event) {
    this.labledisplay = true;
    this.alertCountry = event.value.country_nm;
    this.country_id = event.value.country_id;
    // this.getSearchData(event.value.country_id);
  }

  submitOtherCountryData() {
    console.log(this.country_id);

    this.getSearchData(this.country_id);
  }



  viewLeadsPage(name, id, index) {
    if (this.loginAuth) {
      var user_data = JSON.parse(localStorage.getItem('user_data'));
      var usr_data = user_data[0].reportdata.filter(res => res.chapter_id == this.ProductData[index].chapter && res.chapterend >= this.currentdate);
      if (usr_data.length != 0) {
        if (usr_data[0].chapter_id == this.ProductData[index].chapter) {
          this.navCtrl.push('StartLeadsPage', { 'chid': id, 'name': name });
        } else {
          this.subscribtionalert();
        }
      } else {
        this.subscribtionalert();
      }
    } else {
      this.loginInfoAlert();
    }


  }






  getSearchData(id) {
    console.log(id, "hitted");

    this.otherCnCheck = false;
    this.ProductData = [];

    if (this.search == undefined) return;
    var cid = id;
    var country = JSON.parse(localStorage.getItem('user_data')) ? JSON.parse(localStorage.getItem('user_data')) : [{ usr_country: localStorage.getItem('currency_country_id'), usr_id: null }];
    console.log(country);
    // var setup_country_id=JSON.parse(localStorage.getItem('setup_country_id'))
    // if(!setup_country_id){
    //   country[0].usr_country= country[0].usr_country ;
    // }else{
    //   country[0].usr_country=setup_country_id;
    // }

    if (id == undefined) {

      var data = {
        'country_id': this.geo_country_id,
        // 'country_id':  country[0].usr_country,
        'searchdata': this.search,
        'usr_id': country[0].usr_id
        // 'searchdata' : 'rice'
      }
    } else {
      var data = {
        'country_id': cid,
        'searchdata': this.search,
        'usr_id': country[0].usr_id
        // 'searchdata' : 'rice'
      }
    }
    console.log(data);

    this.apiProvider.searchProductName(data).subscribe((res: any) => {
      console.log(res.data);

      this.ProductData = res.data;
      this.items_data = 10;
      this.country = this.ProductData[0].reporter;
      this.otherCnCheck = true;
    }, er => {
      this.country = this.alertCountry
      this.showAlerts();

    })
  }
  doInfinite(infiniteScroll) {
    setTimeout(() => {
      this.items_data += 10;
      infiniteScroll.complete();
    }, 1000);
  }

  showAlerts() {
    const alert = this.alertCtrl.create({
      cssClass: 'my-custom-class',
      title: 'Oops! No Data Found In' + ' ' + this.alertCountry + ' ' + ' Country!',
      mode: 'ios',
      subTitle: 'Do you want to add information',
      buttons: [
        {
          text: 'No',
          handler: () => {
            this.otherCnCheck = true;
            // console.log('Disagree clicked');
          }
        },
        {
          text: 'Yes',
          handler: () => {
            let modal = this.modalCtrl.create(AddLeadsModel);
            modal.present();



            console.log("hitted");


            // this.finaldeductionAlert()
          }
        }
      ]
    });
    alert.present();

  }


  addChatGroup(id) {
    console.log(this.ProductData[id]);


    if (this.loginAuth) {
      var user_data = JSON.parse(localStorage.getItem('user_data'));
      var usr_data = user_data[0].reportdata.filter(res => res.chapter_id == this.ProductData[id].chapter && res.chapterend >= this.currentdate);
      if (usr_data.length != 0) {
        console.log(usr_data[0].chapter_id == this.ProductData[id].chapter);

        if (usr_data[0].chapter_id == this.ProductData[id].chapter) {
          var groupData = {
            'country_id': this.country_id,
            'usr_id': user_data[0].usr_id,
            'tl': this.ProductData[id].tl,
            'hscode_id': this.ProductData[id].hscode_id,
            'chapter_id': Number(this.ProductData[id].chapter),
            'group_nm': this.ProductData[id].tl,
            'product': this.ProductData[id].product,
            'indicator': 2
          }
          console.log(groupData);

          this.apiProvider.getGroups(groupData).subscribe((res: any) => {

            this.gotoChatPage(id);
            // this.showchatAlerts(1);
            //   this.getSearchData(undefined);
          }, er => {
          })
        } else {
          this.subscribtionalert();
        }
      } else {
        this.subscribtionalert();
      }
    } else {
      this.loginInfoAlert()
    }


  }
  gotoChatPage(id) {

    this.ref.on('value', resp => {

      // console.log('caleed');

      this.rooms = [];
      this.rooms = snapshotToArray(resp).filter(word => word.roomname == this.ProductData[id].tl);
      console.log(this.rooms);

      if (this.rooms.length == 0) {
        console.log('checking', this.rooms.length);
        let newData = this.ref.push();
        newData.set({
          roomname: this.ProductData[id].tl,
          chapter: Number(this.ProductData[id].chapter)
        });
        var newGroupsData = snapshotToArray(resp).filter(word => word.roomname == this.ProductData[id].tl);
        console.log(newGroupsData);

      }

      var data = {
        chapter_id: this.ProductData[id].chapter,
        chapter_cmpr_id: this.ProductData[id].chapter
      }
      // this.navCtrl.push('ChatGroupsPage', { 'chapter_cmpr_id': data });

      // this.navCtrl.push('ChatPage', {
      //   key:this.rooms[0].key,
      //   nickname: JSON.parse(localStorage.getItem('chat_name'))
      // });
      // this.showchatAlerts(1);
      // console.log(this.ProductData[id].chapter);

      // this.getSearchData(undefined);
      // console.log(groupData.chapter_id);

      // this.navCtrl.push('ChatGroupsPage', {
      //   'chapter_cmpr_id':  groupData
      // })

      // return;
    });

    this.navCtrl.push('ChatPage', {
      test: true,
      key: this.ProductData[id].tl,
      nickname: JSON.parse(localStorage.getItem('chat_name'))
    });

  }

  subscribtionalert() {
    const confirm = this.alertCtrl.create({
      cssClass: 'my-custom-class',
      title: 'Please Subscribe',
      message: 'Do you want subscribe?',
      mode: 'ios',
      buttons: [
        {
          text: 'Disagree',
          handler: () => {
            console.log('Disagree clicked');
          }
        },
        {
          text: 'Agree',
          handler: () => {
            this.navCtrl.setRoot('SubscriptionPage')
          }
        }
      ]
    });
    confirm.present();
  }



  showchatAlerts(id) {
    console.log(id);

    if (id == 0) {
      const alert = this.alertCtrl.create({
        cssClass: 'my-custom-class',
        title: 'Sucess',
        mode: 'ios',
        subTitle: 'Successfully Removed From Chat Group',
        buttons: ['OK']
      });
      alert.present();
    } else {

      const alert = this.alertCtrl.create({
        cssClass: 'my-custom-class',
        title: 'Sucess',
        mode: 'ios',
        subTitle: 'Successfully Added To Chat Group',
        buttons: ['OK']
      });
      alert.present();


    }

  }

  removeChatGroup(id) {

    if (this.loginAuth) {
      var data = {
        "chat_id": this.ProductData[id].chat_id,
        'country_id': this.country_id,
        'indicator': 4
      }
      this.apiProvider.removeChatGroup(data).subscribe((res: any) => {
        this.getSearchData(undefined);
        this.showchatAlerts(0);
      }, er => {
      })
    } else {
      this.loginInfoAlert()
    }



  }
  sendtorespond(data) {
    console.log(data)
    this.navCtrl.push(RfqPage, {
      'data': data
    })
  }
  comingsoon() {
    if (this.loginAuth) {
      const confirm = this.alertCtrl.create({
        cssClass: 'my-custom-class',
        title: 'Coming Soon',
        message: '',
        mode: 'ios',
        buttons: ['OK']
      });
      confirm.present();

    } else {
      this.loginInfoAlert()
    }
  }
  gotopage(id) {
    if (id == 0) {
      this.navCtrl.setRoot('HomePage');
    } else if (id == 1) {
      this.navCtrl.push('StartLeadsPage');
    } else if (id == 2) {
      // this.navCtrl.push('ToolkitPage');
      this.navCtrl.push('SelectServicePage');
    } else if (id == 3) {
      this.navCtrl.push('ChatChaptersPage');
    } else if (id == 4) {
      this.navCtrl.push('LeadsTabsPage');
    }

  }

}

export const snapshotToArray = snapshot => {
  let returnArr = [];

  snapshot.forEach(childSnapshot => {
    let item = childSnapshot.val();
    item.key = childSnapshot.key;
    returnArr.push(item);
  });

  return returnArr;
};


@Component({
  selector: 'page-policyadd',
  templateUrl: 'add-policies.html',
})
export class AddPoliciesModel {
  indicator;
  poliData; loading: any;
  addPoliciesForm: FormGroup;
  addRfqForm: FormGroup;
  allCountrys: any[] = []; restricteddata: any; finalrestrictdata: any;
  rfqmobile: any; rfqemail: any; rfqname: any; allcurrencyData: any;
  measurement: any[] = [{ id: '1', name: 'CRT' }, { id: '2', name: 'CUM' }, { id: '3', name: 'KGS' }, { id: '4', name: 'LTR' }, { id: '5', name: 'MTR' }, { id: '6', name: 'NOS' }, { id: '7', name: 'PRS' }, { id: '8', name: 'SQM' }, { id: '9', name: 'THN' }, { id: '10', name: 'TON' }];
  constructor(public loadingCtrl: LoadingController, public navCtrl: NavController, public navParams: NavParams, private apiProvider: ApiProvider, private fb: FormBuilder, private alertCtrl: AlertController,) {
    this.leadrestrictioncnts();
    var user_data = JSON.parse(localStorage.getItem('user_data'));
    this.rfqname = user_data[0].usr_nm;
    this.rfqmobile = user_data[0].usr_ph;
    this.rfqemail = user_data[0].usr_email;
    console.log(this.rfqname);


    this.addPoliciesForm = fb.group({
      policyname: [this.rfqname, [Validators.required]],
      policymobile: [this.rfqmobile, [Validators.required]],
      policyemail: [this.rfqemail, [Validators.required, Validators.email]],
      policyorganisation: ['', [Validators.required]],
      policycountry_nm: ['', [Validators.required]],
      policy_subject: ['', [Validators.required]],
      policy_url: ['', [Validators.required]],
    })

    this.addRfqForm = fb.group({
      rfqname: [this.rfqname, [Validators.required]],
      rfqmobile: [this.rfqmobile, [Validators.required]],
      rfqemail: [this.rfqemail, [Validators.required, Validators.email]],
      rfqorganisation: ['',],
      rfqcountry_nm: ['', [Validators.required]],
      rfqquantity: ['', [Validators.required]],
      rfqunit_of_measurement: ['', [Validators.required]],
      rfqunit_price: ['', [Validators.required]],
      rfqcurrency: ['', [Validators.required]],

    })

    this.indicator = this.navParams.get('indc')

    // this.getContinent()
    this.poliData = this.navParams.get('poli');
    this.getallCountrysData()
    this.currencyData();
    //  console.log(this.poliData,   this.indicator );

  }

  get signupformControl() {
    return this.addPoliciesForm.controls;
  }

  get rfqControlForm() {
    return this.addRfqForm.controls;
  }

  private getallCountrysData() {
    this.apiProvider.getallCountrys().subscribe((res: any) => {
      console.log(res.data)
      this.allCountrys = res.data;
      console.log(this.allCountrys);
    }, er => {
      console.log(er);
    })
  }


  closeModal() {
    this.navCtrl.pop();
  }

  onSubmit() {
    this.presentLoadingIos();
    var user_data = JSON.parse(localStorage.getItem('user_data'))

    var policyData = {
      'policyname': this.addPoliciesForm.value.policyname,
      'policymobile': this.addPoliciesForm.value.policymobile,
      'policyemail': this.addPoliciesForm.value.policyemail,
      'policycountry_nm': this.addPoliciesForm.value.policycountry_nm,
      'policyorganisation': this.addPoliciesForm.value.policyorganisation,
      'policy_subject': this.addPoliciesForm.value.policy_subject,
      'policy_url': this.addPoliciesForm.value.policy_url,
      'policy_hscode_id': this.poliData.hscode_id,
      'policy_hscode_no': this.poliData.tl,
      'policy_country_id': user_data[0].usr_country,
      'user_id': user_data[0].usr_id,
      'indicator': this.indicator
    }
    console.log(policyData);

    this.apiProvider.addPoliciesData(policyData).subscribe((res: any) => {
      this.loading.dismiss();
      console.log(res);
      this.navCtrl.pop();
    }, er => {
    })

  }
  leadrestrictioncnts() {
    var userdata = JSON.parse(localStorage.getItem('user_data'));
    var data = {
      'indicator': 1,
      'usr_id': userdata[0].usr_id,
    }
    this.apiProvider.getrestrictiondata(data).subscribe((res: any) => {

      console.log(res.data);
      this.restricteddata = res.data;

      // this.agenciesdata = res.data;
    }, er => {
      console.log(er);
    })
  }
  presentLoadingIos() {
    this.loading = this.loadingCtrl.create({
      spinner: 'ios',
      content: 'Please wait...'
    });
    this.loading.present();
  }

  onRfqSubmit() {
    this.presentLoadingIos();
    this.finalrestrictdata = this.restricteddata.filter(word => word.lead_ctgry_restrict_type_id == 5);

    var user_data = JSON.parse(localStorage.getItem('user_data'))

    var rfqData = {
      'rfqname': this.addRfqForm.value.rfqname,
      'rfqemail': this.addRfqForm.value.rfqemail,
      'rfqmobile': this.addRfqForm.value.rfqmobile,
      'rfqorganisation': this.addRfqForm.value.rfqorganisation,
      'rfqcountry_nm': this.addRfqForm.value.rfqcountry_nm.country_nm,
      'rfqquantity': this.addRfqForm.value.rfqquantity,
      'rfqunit_of_measurement': this.addRfqForm.value.rfqunit_of_measurement,
      'rfqunit_price': this.addRfqForm.value.rfqunit_price,
      'rfqhscode_id': this.poliData.hscode_id,
      'rfqcountry_id': user_data[0].usr_country,
      'rfqusr_id': user_data[0].usr_id,
      'rfqcurrency': this.addRfqForm.value.rfqcurrency.currency_cd,
      'rfq_hscode_no': this.poliData.tl,
      'finalrestrictdata': this.finalrestrictdata
    }
    console.log(rfqData);

    this.apiProvider.addRFQData(rfqData).subscribe((res: any) => {
      console.log(res);
      this.loading.dismiss();
      // this.navCtrl.pop();

      if (res.status == 200) {
        const alert = this.alertCtrl.create({
          // cssClass: 'my-custom-class',
          cssClass: 'successcolorclass',
          title: res.referral,
          subTitle: 'Congratulations!, Your Request has received and our team will get back to you in next 72 Hrs',
          mode: 'ios',
          buttons: [{
            text: 'Ok',
            handler: () => {
              location.reload();
              this.navCtrl.pop();
            }
          },
          ]
        });
        alert.present();

      }
    }, er => {
    })

  }

  numericOnly(event): boolean {
    let patt = /^([0-9])$/;
    let result = patt.test(event.key);
    return result;
  }
  currencyData() {
    this.apiProvider.getCurrency().subscribe((res: any) => {
      console.log(res.status);
      this.allcurrencyData = res.data
      //  this.allcurrencyData.push(res);
      console.log(this.allcurrencyData);
    })
  }

}



// WEBPACK FOOTER //
// ./src/pages/search/search.ts